export const DISADVANTAGED_COMMUNITY = 'disadvantaged community';

export const ASSISTANCE = 'assistance';

export const FILING_PREVIOUS_YEAR = 'filing (previous year)';

export const FILING_CURRENT_YEAR = 'filing (current / previous year)';
